export interface IModelScopeMasterResponse {
  id: number;
  name: string;
  scope: string;
  hostName: string | null;
  urlPath: string | null;
  type: string;
  status: string;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export class ModelScopeMaster {
  id: number;
  name: string;
  scope: string;
  hostName: string | null;
  urlPath: string | null;
  type: string;
  status: string;
  createdAt: string | Date;
  updatedAt: string | Date;

  constructor(props = {} as IModelScopeMasterResponse) {
    props = props ?? {}
    this.id = props.id;
    this.name = props.name;
    this.scope = props.scope;
    this.hostName = props.hostName;
    this.urlPath = props.urlPath;
    this.type = props.type;
    this.status = props.status;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
  }
}

export interface IModelCreateScopeMasterRequest {
  name: string;
  scope: string;
  hostName: string;
  urlPath: string;
  type: string;
  status: string;
}
